import {PageTitle} from '~/GalleryPB/components/PageTitle';
import {Link} from '~library/atoms/Link';
import {Picture} from '~library/atoms/Picture';

import * as styles from './NoFavorites.module.scss';

export const NoFavorites = () => (
  <>
    <PageTitle text="My favorites" numTemplates={0} />
    <div className={styles.wooHoomanWrapper}>
      <Picture
        alt=""
        srcSet={[
          '/assets/images/illustrations/woohooman.avif',
          '/assets/images/illustrations/woohooman.mp4',
          '/assets/images/illustrations/woohooman.gif',
        ]}
      />
      <p className={styles.galleryLink}>
        You haven't favorited any designs yet. Check out{' '}
        <Link href="/gallery" data-qa-id="galleryNoFavoritesFeaturedLink">
          these new and trending invitations
        </Link>{' '}
        to start your list!
      </p>
    </div>
  </>
);
